import React, {
	HTMLAttributes,
	ReactNode,
	useRef,
} from 'react';
import './AccordionItem.css';
import ReactHtmlParser from 'react-html-parser';
import Icon from '../../../atoms/Icon';
import Title from '../../../atoms/Title';

export type AccordionEntry = {
	icon?: {
		iconAltText: string;
		iconPath: string;
		size: 'utility' | 'badge';
	};
	title?: ReactNode;
	content?: ReactNode;
};

export interface IAccordionItemProps extends HTMLAttributes<any> {
	item: AccordionEntry;
	index: number;
	active?: boolean;
	backgroundColor?: 'white' | 'light-grey';
	enableIcons?: boolean;
	disableBorder?: boolean;
	headerUnder?: boolean;
	onClick: THandlerFunction;
	additionalOnClick?: THandlerFunction;
}

const bgColorClasses = { 
	'white': 'bg-white',
	'light-grey': 'bg-grey-alabaster'
}

const AccordionItem = ({
	item,
	id,
	index,
	active = false,
	backgroundColor,
	enableIcons = false,
	disableBorder = false,
	headerUnder = false,
	onClick,
	additionalOnClick,
}: IAccordionItemProps) => {

	const contentRef = useRef<HTMLDivElement>(null);
	const { icon, title, content } = item;

	return (
		<li className={`AccordionItem text-grey-tundora list-none flex flex-col ${!disableBorder ? 'AccordionItem--border' : ''} ${backgroundColor ? bgColorClasses[backgroundColor] : ''}`}>
			<button
				className={`AccordionItem__headerContainer p-0 bg-transparent no-underline border-none m-0 w-full block ${headerUnder ? 'AccordionItem__headerContainer--bottom  ':''}`}
				aria-controls={`${id}-${index}`}
				aria-expanded={active}
				tabIndex={0}
				onClick={(evt) => {
					onClick(index);
					additionalOnClick && additionalOnClick(evt);
				}}
			>
				<div className='AccordionItem__header flex items-center cursor-pointer'>
					{enableIcons && icon ? (
							<Icon className='mr-4' loading='lazy' alt={icon.iconAltText} src={icon.iconPath} size={icon.size}/>
						) : (
							<React.Fragment></React.Fragment>
						)
					}
					<Title tag='p' className='AccordionItem__title !text-base !m-0 text-start pr-4 font-bold'>
						{typeof title ==='string' ? ReactHtmlParser(title) : title}						
					</Title>
					<span className={`AccordionItem__expandArrow ${active ? 'active' : 'inactive'}`}></span>
				</div>
			</button>
			<div 
				className={`AccordionItem__contentContainer ${active ? 'active' : 'inactive'}${headerUnder?'--bottom':''}`}
				aria-expanded={active}
				id={`${id}-${index}`}
				style={{
					maxHeight: active ? contentRef.current?.clientHeight : '0',
					visibility: active ? 'visible' : 'hidden',
				}}
			>
				<div ref={contentRef} className='AccordionItem__content'>
					{typeof content ==='string' ? ReactHtmlParser(content): content}
				</div>
			</div>
		</li>
	)
};

export default AccordionItem;
